module.exports = __webpack_public_path__ + "img/066.a59bf84d.png";